import React, { useRef } from 'react'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { FormControlLabel, FormLabel, Radio, RadioGroup, TextField, Typography } from '@mui/material'
import orologo from "../Image/oro-logo.jpeg";
import mpcst from "../Image/newmpcst-logo.jpg";
import logopublic from "../Image/publicqr.jpeg";
import { useLocation } from "react-router-dom";
import ResultPDF from "./ResultPDF";
const Results = ({ screeningResult,phone ,riskhabits,name,dob,gender,address }) => {
  const location = useLocation();
  const images = location.state?.images || [];
  const pdfRef = useRef()
  console.log("we are getting risks: "+riskhabits);
  
  const downloadPDF = async () => {
    const element = pdfRef.current;
  
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      windowWidth: 794,
    });
  
    const imgData = canvas.toDataURL("image/png");
  
    const pdf = new jsPDF("p", "mm", "a4");
  
    const imgWidth = 210;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
  
    pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
  
    pdf.save("Screening_Result.pdf");
  };

  
  return (
    <div className='result-page-bg'>


          <div className='doctor-nner-wrapper' >
            

            <div className='header-body'>
            <div className='result_pdf_download_btn_container'>
              
                <input className='text-btn result_page_download_pdf_button' type="button" value="Download PDF" onClick={downloadPDF}/>
            </div>
            <div className='pdf_container' ref={pdfRef}>

            <div className='logo_container_pdf_container' >
              <img src={orologo} alt=""/>

               <label className='label-h4' htmlFor="logo">
                ORAL CANCER SCREENING: PROVISIONAL REPORT
                </label>
                 <img src={mpcst} alt=""/>
              </div>
              <div className='text-field'>
                <div>
                  <span><strong>Name: </strong><p>{name}</p></span>
                  <span><strong>Age: </strong><p>{phone}</p></span>
                  <span><strong>Address: </strong><p>{address}</p></span>
                   <span><strong>Date of Screening: </strong><p></p></span>
                  
                </div>
                
              </div>
              <div className='text-field'>
                <div className='radio-filed'>
                  <RadioGroup row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                  </RadioGroup>
                </div>
              </div>
          
              <div className='text-field'>
                <Typography variant='body1'>
                  <strong>Risk Habit:</strong> {riskhabits.length > 0 ? riskhabits.join(", ") : "None Reported"}
                </Typography>
              </div>
              <div className='text-field'>
                <Typography variant='body1'>Based on your habits , the questionnaires that you filled and the
                  photograph you uploaded you are provisionally diagnosed /Screened    <strong>{screeningResult}</strong>
                  </Typography>
              </div>
         
              <div className="image-section">
                {images.length > 0 ? (
                  images.map((img, index) => (
                    <img
                      className="result_patient_image"
                      key={index}
                      src={`${img}`} // IMPORTANT if backend
                      alt={`uploaded-${index}`}
                    />
                  ))
                ) : (
                  <p>No image uploaded</p>
                )}
              </div>
              <div className='text-field'>
                <Typography variant='body1'>This is only a provisional diagnosis . For further confirmation you should visit your nearby Doctor or Hospital</Typography>
              </div>
              <div className='text-field'>
                <Typography variant='body1'><b>Disclaimer:</b>
This report has been generated by a mobile application for preliminary screening and informational purposes only and should not be considered a clinical diagnosis. The results are based solely on the information and/or images provided by the user, and their accuracy depends on the correctness, completeness, and quality of these inputs. Image-based assessments may be affected by factors such as lighting, angle, and device limitations. 
This report does not establish a doctor–patient relationship, does not provide medical advice, and does not recommend any treatment or medication. It is not intended for use in medical emergencies; in case of urgent symptoms, immediate medical attention should be sought. The findings are indicative in nature, may vary over time, and are not final or conclusive. Users are strongly advised to consult a qualified healthcare professional for a comprehensive clinical evaluation and definitive diagnosis, which may include further investigations such as biopsy if required.
This report is not valid for medico-legal purposes. The developers and associated institutions shall not be held liable for any decisions made or actions taken based solely on this report. User data is handled in accordance with the application’s privacy policy; however, users are advised to exercise discretion while sharing sensitive information.
</Typography>
              </div>
              <div className='qr-img'>
              <img src={logopublic} alt=""/>
              </div>
             <div className='result-text-bottom'>
              <Typography>
                One scan. One minute 
              </Typography>
              <Typography>A quick check to know if your mouth shows signs of serious disease</Typography>
             </div>
   
            </div>

            </div>
          </div>
      </div>
  )
}

export default Results
